import { createGlobalStyle, css } from 'styled-components';

import { HEADER_HEIGHT, SCROLL_BAR_WIDTH } from 'constants/sizes';

import * as fonts from './fonts';

export const GlobalStyles = createGlobalStyle`
    * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    overflow-x: hidden;
    overflow-y: hidden;
    ${({ theme }) => css`
      color: ${theme.colors.white.main};
      background-color: ${theme.colors.black.main};
    `};
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 0;
    height: 10px;
    width: ${SCROLL_BAR_WIDTH};
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  ::-webkit-scrollbar:hover {
    background-color: transparent;
  }

  ::-webkit-scrollbar:active {
    background-color: transparent;
  }

  ${({ theme }) => css`
    html {
      *:hover::-webkit-scrollbar {
        background-color: transparent;
      }

      *:hover::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.lightGrey.main};
        background-clip: padding-box;
        border-radius: 4px;
      }

      *::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.colors.lightGrey.hover};
      }

      *::-webkit-scrollbar-thumb:active {
        background-color: ${theme.colors.lightGrey.hover};
      }

      * {
        // ff scrollbar
        scrollbar-width: thin;
        scrollbar-color: ${theme.colors.lightGrey.main} transparent;
      }
    }
  `};

  .app {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden
  }

  .main-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    overflow-y: unset;
  }

  .main {
    width: 100%;
    height: 100%;
    max-width: 1600px;
    margin: 0 auto;
    
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .page-container {
    flex: 1;
    overflow-y: scroll;

    ${({ theme }) => css`
      padding-top: ${HEADER_HEIGHT};
      padding-left: ${theme.padding.biggest};
      padding-right: ${theme.padding.biggest};
    `}
  }

  h1 {
    ${fonts.h1};
  }

  h2 {
    ${fonts.h2};
  }

  h3 {
    ${fonts.h3};
  }

  p {
    ${fonts.body};
  }

  h5 {
    ${fonts.h5};
  }

  .italic {
    font-style: italic;
  }

  a {
    outline: none;
    text-decoration: none;
    ${({ theme }) => css`
      color: ${theme.colors.white.main};

      &:hover {
        color: ${theme.colors.white.hover};
      }

      &:active {
        color: ${theme.colors.white.active};
      }
    `}
  }

  ul {
    list-style-type: none;
  }

  .ellipsis{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
